import styled from 'styled-components';
import { BaseCard as CommonCard } from '@app/components/common/BaseCard/BaseCard';

export const TablesWrapper = styled.div`
  margin-top: 0.5rem;
`;

export const Card = styled(CommonCard)`
  margin-bottom: 2rem;
`;
